import React from 'react';
import { formatDescriptions } from '../utils/utils';
import { useIdPrefix } from '@jbhi-fi/components/src/IdPrefix';
import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
import { styles } from './KeyFeatures.css';

export type KeyFeaturesProps = {
  features?: Array<string>;
  highlight?: string;
  requiresExtraDescriptions?: boolean;
};

export const KeyFeatures = ({ features, highlight, requiresExtraDescriptions }: KeyFeaturesProps): JSX.Element => {
  const isHighlightOnly = !features?.length;
  const sanitizedHighlight = formatDescriptions(highlight);

  const elementIds = {
    wrapper: useIdPrefix('kf-summary'),
    title: useIdPrefix('kf-title'),
    listContainer: useIdPrefix('kf-list-container'),
  };

  if (highlight && !highlight.length && !features.length) return null;

  return (
    <div id={elementIds.wrapper} className={styles.keyFeaturesSection({ isHighlightOnly })}>
      {features && features.length ? (
        <DomFont className={styles.keyFeaturesTitle} id={elementIds.title}>
          Key features
        </DomFont>
      ) : (
        <DomFont className={styles.descriptionTitle} id={elementIds.title}>
          Description
        </DomFont>
      )}
      {!requiresExtraDescriptions && highlight && highlight.length ? (
        <div className={styles.highlight} dangerouslySetInnerHTML={{ __html: sanitizedHighlight }}></div>
      ) : null}
      {features && features.length ? (
        <div className={styles.keyFeaturesContainer} id={elementIds.listContainer}>
          <ul className={styles.keyFeatures}>
            {features.map((feature, i) => (
              <li key={i}>{feature}</li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default KeyFeatures;
